<template><div>
	<div class="form-group clearFix">
		<label class="control-label tex-left tex-width fl">页面名称：</label>
		<div class="col-sm">
			<Input size="large" v-model="frmdata.name" placeholder="请输入..." class="con-width"></Input>
		</div>
	</div>
	<div class="form-group clearFix">
		<label class="control-label tex-left tex-width fl">导航显示：</label>
		<div class="col-sm">
			<i-switch v-model="frmdata.display">
				<span slot="open">是</span>
                <span slot="close">否</span>
			</i-switch>
		</div>
		<span class="check-tip">页面名称将出现在导航中</span>
	</div>
</div></template>

<script>
let enumArr = ['display', 'ishome'];
export default
{
	name: 'page_settings',
	computed: {
		frmdata (){
			let _pageinfo = this.pageinfo;
			enumArr.forEach((v, k) => {
				_pageinfo[v] = (_pageinfo[v] == '1') ? true : false
			});
			return _pageinfo
		},
	},
	props: ['pageinfo'],
}
</script>


// WEBPACK FOOTER //
// pageset.vue?3591f974